export const mapGiftedCreditBalanceToLessonPack = (creditBalance, index) => ({
  id: `gifted-${creditBalance.lessonType?.id}-${index}`,
  totalCredits: creditBalance.totalCredits,
  remainingCredits: creditBalance.remainingCredits,
  expiresAt: creditBalance.nextExpirationDate,
  lessonCredits: [],
  isGifted: true,
  lessonType: {
    ...creditBalance.lessonType,
    giftingEnabled: false,
  },
})

export const mapGiftedCreditBalances = creditBalances =>
  creditBalances.map(mapGiftedCreditBalanceToLessonPack)
